import { render, staticRenderFns } from "./Platelet.vue?vue&type=template&id=603d456d&"
import script from "./Platelet.vue?vue&type=script&lang=js&"
export * from "./Platelet.vue?vue&type=script&lang=js&"
import style0 from "./Platelet.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports